import React, {useContext, useEffect, useMemo, useState} from "react";
import AutoLinkText from "react-autolink-text2";
import UIMessageLink from "./UIMessageLink";
import {useTranslation} from "react-i18next";
import _ from "lodash";
import classNames from "classnames";
import styles from "./UIMessageReply.module.scss";
import profil from "../images/UIChatRoom-profil2.png";
import {messageTypes, sendStatus} from "../ChatConstants";
import UIMessageMention from "./UIMessageMention";
import UIMessageImage from "./UIMessageImage";
import playImg from "../images/playImg.png";
import UIFileType from "./UIFileType";
import {getUrl} from "src/service/files.service";
import {AppContext} from "src/pages/context/App.context";

const fileServiceDownloadURL =
  window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/downloadFile?fileId=";

const UIMessageReply = (props) => {
  const { t } = useTranslation();
  let membersDetail;
  let profile;
  let userName = "";
  const appCtx = useContext(AppContext);
  const replyDetails =
    props.messageNew?.messageReplyDetails?.length > 0
      ? props.messageNew?.messageReplyDetails
      : !_.isEmpty(props.messageNew?.messageDetails)
      ? [props.messageNew?.messageDetails]
      : [];

  const isImageReply = useMemo(
    () => props?.msgObj?.messageDetails?.messageType === "image",
    []
  );

  const isVideoReply = useMemo(
    () => props?.msgObj?.messageDetails?.messageType === "video",
    []
  );

  const isFileReply = useMemo(
    () => props?.msgObj?.messageDetails?.messageType === "center_file",
    []
  );

  const videoDetails = useMemo(() => {
    return isVideoReply
      ? props?.msgObj?.messageDetails?.messageDetails?.videoDetails[0]
      : null;
  }, []);

  const fileDetails = useMemo(() => {
    return isFileReply
      ? props?.msgObj?.messageDetails?.messageDetails?.fileDetails[0]
      : null;
  }, []);

  if (replyDetails?.length === 0) {
    replyDetails = props?.storageMessageList?.filter(
      (item) => item?.messageId === props?.messageReplyId
    );
  }

  const userIdReply = replyDetails[0]?.userId || "";
  membersDetail = props.tempMember?.filter((item) => {
    return item?.userId?.indexOf(userIdReply) !== -1;
  });

  if (membersDetail?.length > 0) {
    profile = membersDetail[0]?.user?.profile;
    userName = membersDetail[0]?.user?.username;
  }

  const renderText = (text) => {
    if (text.length > 200) {
      return text.substr(0, 200) + "...";
    }

    return text;
  };

  React.useEffect(() => {
    console.log(props.msgObj);
  }, []);

  useEffect(() => {
    checkGetUrlFile();
  }, []);
  const [urlvideo, setUrlvideo] = useState("");
  const checkGetUrlFile = async () => {
    let url = fileServiceDownloadURL + videoDetails?.id + "&size=1024";
    url = await getUrl(url, videoDetails?.id, 1024, "chat");
    setUrlvideo(url);
  };

  return (
    <div
      className={styles.boxMessage}
      style={
        props.isAnother > 1
          ? !props.graphDetail?.videos
            ? { marginLeft: "auto" }
            : { marginLeft: "auto", maxWidth: "250px" }
          : !props.graphDetail?.videos
          ? undefined
          : { maxWidth: "250px" }
      }
    >
      {/* ============= Box Top message ============= */}
      <div
        className={classNames(
          "chat-caption",
          props.isAnother > 1
            ? styles.msgStyleReplyTop2
            : styles.msgStyleReplyTop1
        )}
        // style={{maxWidth: isImageReply ?'100%': '50%'}} // old version
        style={{ maxWidth: "100%",cursor:"pointer" }}
        onClick={ async () => {
            appCtx.setIsSearchingReply(false);
            appCtx.setCurrentMessageReplyId(null);
            appCtx.setCurrentMessageReplyIdOnPress(null);
            appCtx.setDistanceReply(null)
            appCtx.setDistanceReply(props.messageNew?.messageDetails.distanceReply)
            appCtx.setCurrentMessageReplyIdOnPress(props.messageNew?.messageId);
            try {
              appCtx.setCurrentMessageReplyId((props.messageNew?.messageReplyDetails[0]?.messageRefId === undefined) ? props.messageNew?.messageReplyId : props.messageNew?.messageReplyDetails[0]?.messageRefId)
            } catch (error) {
              appCtx.setCurrentMessageReplyId(props.messageNew?.messageReplyId)
            }
            appCtx.setIsSearchingReply(true)
          }
      }
      >
        {replyDetails?.length > 0 ? (
          <>
            <div
              className={classNames("chat-message", styles.boxTop)}
              id={"reply_" + props.messageNew?.messageReplyId}
            >
              {/* <div
              className={classNames("profile-img-reply")}
              id={"imageReply_" + props.messageNew?.messageReplyId}
              style={{ paddingRight: "10px" }}
            >
              <div
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "50%",
                  backgroundColor: "#b8b8b8",
                  backgroundPosition: "0",
                  backgroundImage: `url(${profile || profil})`,
                  backgroundSize: "cover",
                }}
              ></div>
            </div> */}
              <div className={styles.detailWrapper}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      minWidth: "42px",
                      minHeight: "42px",
                      width: "42px",
                      height: "42px",
                      borderRadius: "50%",
                      backgroundColor: "#b8b8b8",
                      backgroundPosition: "0",
                      backgroundImage: `url(${profile || profil})`,
                      backgroundSize: "cover",
                      marginRight: 10,
                    }}
                  ></div>
                  <div
                    className={
                      props.isAnother > 1 ? styles.username1 : styles.username2
                    }
                  >
                    {userName}
                  </div>
                </div>
                <div id={"textReply_" + props.messageNew?.messageReplyId}>
                  {replyDetails[0]?.messageText !== sendStatus.Unsend
                    ? renderText(replyDetails[0]?.messageText)
                    : t("Message unavailable")+"."}
                </div>
              </div>
            </div>

            {isImageReply && (
              <UIMessageImage
                key={props?.msgObj?.messageId}
                handlePreviewImage={() => {}}
                isAnother={props.isAnother}
                msgObj={props?.msgObj}
                messageURLlocal={props?.msgObj?.messageDetails?.messageDetails}
                messageDetails={props?.msgObj?.messageDetails?.messageDetails}
              />
            )}

            {isVideoReply && (
              <div className={styles.videoReplyWrapper}>
                <img
                  src={urlvideo}
                  style={{
                    maxWidth: "150px",
                    height: "auto",
                    borderRadius: "10px",
                  }}
                />

                <div
                  className={styles.videoPlayBtn}
                  style={{ backgroundImage: `url(${playImg})` }}
                />
              </div>
            )}

            {isFileReply && (
              <div className={styles.fileReplyWrapper}>
                <UIFileType type={fileDetails?.fileType} />
                <div style={{ marginLeft: 10 }}>{fileDetails?.fileName}</div>
              </div>
            )}
          </>
        ) : (
          <div className={classNames("chat-message", styles.boxTop)}>
            <span>{t("Message unavailable.")}</span>
          </div>
        )}
      </div>
      {/* ============= Box Bottom message ============= */}
      <div
        className={
          !props.graphDetail?.videos
            ? classNames(
                "chat-message",
                props.isAnother > 1
                  ? styles.msgStyleReplyBottom2
                  : styles.msgStyleReplyBottom1
              )
            : classNames("chat-message")
        }
        // style={{maxWidth: isImageReply ?'100%': '50%'}}  // old version
        style={{ maxWidth: "100%" }}
      >
        {props.messageNew.messageType === messageTypes.Link ? (
          <UIMessageLink
            graphDetail={props.graphDetail}
            text={props.messageNew.messageText}
            isAnother={props.isAnother}
          />
        ) : (
          <React.Fragment>
            {props.messageNew?.mentionProperty ? (
              <UIMessageMention
                msgObj={props.messageNew}
                onClickMention={props.handleSelectedUser}
              />
            ) : (
              <AutoLinkText
                text={props.messageNew.messageText}
                linkProps={{
                  target: "_blank",
                  onClick: props.handleOpenLink,
                }}
              />
            )}
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default React.memo(UIMessageReply);
